import type { SVGProps } from 'react';

export function BackMarketIcon(props: SVGProps<SVGSVGElement>) {
   return (
      <svg
         width="128"
         height="128"
         viewBox="0 0 128 128"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         {...props}
      >
         <rect width="128" height="128" fill="#DDF869" />
         <path
            d="M52.9046 90H68.4538C68.8787 90 69.0911 89.4922 68.7906 89.1917L44.1585 64.5596C43.8528 64.2487 43.8528 63.7513 44.1585 63.4456L68.7906 38.8135C69.0911 38.5181 68.8787 38.0052 68.4538 38.0052H52.9046C52.4072 38.0052 51.9357 38.2021 51.5834 38.5544L26.6922 63.4456C26.3865 63.7565 26.3865 64.2539 26.6922 64.5596L51.5834 89.4508C51.9357 89.8031 52.4072 90 52.9046 90Z"
            fill="#061743"
         />
         <path
            d="M101.397 89.1917L76.7647 64.5596V64.5544C76.459 64.2435 76.459 63.7461 76.7647 63.4404L101.397 38.8083C101.697 38.513 101.485 38 101.06 38H85.5108C85.0134 38 84.5419 38.1969 84.1896 38.5492L59.2984 63.4404C58.9927 63.7513 58.9927 64.2487 59.2984 64.5544L84.1896 89.4508C84.5419 89.8031 85.0134 90 85.5108 90H101.06C101.485 90 101.697 89.4922 101.397 89.1917Z"
            fill="#061743"
         />
      </svg>
   );
}
